import { Text } from '@moda/om';
import React from 'react';
import classNames from 'classnames';
import { NavigatorVerticalItemFragment } from '../../../generated/types';
import { Link } from '../../Link';

import './DesktopNavigationV2MainContentCategory.scss';

type Props = {
  category: NavigatorVerticalItemFragment;
  selected: boolean;
  onSelect: () => void;
};

export const DesktopNavigationV2MainContentCategory: React.FC<Props> = ({
  category,
  selected: isSelected,
  onSelect
}) => {
  return (
    <Link
      className={classNames('DesktopNavigationV2MainContentCategory', {
        'DesktopNavigationV2MainContentCategory--selected': isSelected,
        'DesktopNavigationV2MainContentCategory--unselected': !isSelected
      })}
      to={category.href}
      data-testid="DesktopNavigationV2MainContentCategory"
      onMouseOver={onSelect}
    >
      <Text
        treatment={category.style.bold ? 'bold1' : undefined}
        color="klein-blue"
        style={category.style.color ? { color: category.style.color } : undefined}
      >
        {category.name}
      </Text>
    </Link>
  );
};
